import script from "./ComprobanteEntrega.vue?vue&type=script&setup=true&lang=js"
export * from "./ComprobanteEntrega.vue?vue&type=script&setup=true&lang=js"

import "./ComprobanteEntrega.vue?vue&type=style&index=0&id=e2e25828&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2e25828"]])

export default __exports__